let LabelClass = null

// 기존 kakao.maps.CustomOverlay(마커 라벨) 대체용 google.maps.OverlayView 서브클래스.
// google.maps 로드 이후에만 정의할 수 있어 팩토리로 제공한다.
// 카카오 CustomOverlay처럼 content의 중심이 position에 오도록 배치한다.
export function getMapLabelClass (maps) {
  if (LabelClass) return LabelClass

  function MapLabelOverlay (options) {
    this.position = options.position
    this.content = options.content
    this.div = null
    if (options.map) this.setMap(options.map)
  }

  MapLabelOverlay.prototype = Object.create(maps.OverlayView.prototype)

  MapLabelOverlay.prototype.onAdd = function () {
    this.div = document.createElement('div')
    this.div.style.position = 'absolute'
    this.div.style.transform = 'translate(-50%, -50%)'
    this.div.style.whiteSpace = 'nowrap'
    this.div.innerHTML = this.content
    this.getPanes().overlayMouseTarget.appendChild(this.div)
  }

  MapLabelOverlay.prototype.draw = function () {
    if (!this.div) return
    const projection = this.getProjection()
    if (!projection) return
    const point = projection.fromLatLngToDivPixel(this.position)
    if (!point) return
    this.div.style.left = point.x + 'px'
    this.div.style.top = point.y + 'px'
  }

  MapLabelOverlay.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) this.div.parentNode.removeChild(this.div)
    this.div = null
  }

  LabelClass = MapLabelOverlay
  return LabelClass
}



// WEBPACK FOOTER //
// ./src/util/MapLabelOverlay.js